import { render, staticRenderFns } from "./ClinicalActivity.vue?vue&type=template&id=51b3d4ee&scoped=true"
import script from "./ClinicalActivity.vue?vue&type=script&lang=js"
export * from "./ClinicalActivity.vue?vue&type=script&lang=js"
import style0 from "./ClinicalActivity.vue?vue&type=style&index=0&id=51b3d4ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b3d4ee",
  null
  
)

export default component.exports